import { type FunctionComponentElement, type ReactNode, useRef } from "react";

import { Stack, useClickOutside } from "@shapr3d/frontend-lib";
import classNames from "classnames";

import style from "./Flyout.module.css";

interface FlyoutProps {
  children: ReactNode;
  activator: FunctionComponentElement<{ onClick: React.MouseEventHandler }>;
  open: boolean;
  onClose: () => void;
  className?: string;
}

export const Flyout: React.FC<FlyoutProps> = ({
  children,
  className,
  activator,
  open,
  onClose,
}) => {
  const clickOutsideTarget = useRef(null);

  useClickOutside(clickOutsideTarget.current, () => {
    if (open) onClose?.();
  });

  return (
    <div
      data-testid="ar-flyout"
      ref={clickOutsideTarget}
      className={classNames(style.flyoutWrapper, className)}
    >
      {activator}
      {open && (
        <div role="menu" className={classNames(style.dropdownWrapper)}>
          <Stack className={classNames(style.flyout)} direction={"column"}>
            {children}
          </Stack>
        </div>
      )}
    </div>
  );
};
